import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { moveObject } from '@widgets/Files/api/moveObject';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';

export const useMoveObject = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['moveObject'],
        mutationFn: moveObject,
        onSuccess: (data) => {
            handleStatusError(data, t('useFileUpload.return.swal.manyFiles.button'));
            if (data.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files'] });
            }
        },
    });
};
